export const environment = {
  production: true,
  apiUrl: 'https://staging-api.trendmulti.com.br/api',
  baseUrl: 'https://staging-api.trendmulti.com.br',
  trendWebAppUrl: 'https://hml-app.trendmulti.com.br',
  trendWebAdminUrl: 'https://staging-admin.trendmulti.com.br',
  trendCacheUrl: 'https://staging-cache.trendmulti.com.br',
  trendPaymentUrl: 'https://staging-payment.trendmulti.com.br',
  firebase: {
    apiKey: 'AIzaSyDwaQRKkoYjB2wABnzOyTTdsyKloHSO-LA',
    authDomain: 'zapteck-2707e.firebaseapp.com',
    databaseURL: 'https://zapteck-2707e.firebaseio.com',
    projectId: 'zapteck-2707e',
    storageBucket: 'zapteck-2707e.appspot.com',
    messagingSenderId: '1065124905487',
    appId: '1:1065124905487:web:151104c20ff06dcab2197a',
    measurementId: 'G-JHRXV6S0LG',
  },
}
